import getSpells from './get_spells';
import castSpell from './cast_spell';

export default function castSpells(form) {
  return getSpells(form)
    .split(',')
    .filter((spell) => spell !== '')
    .map((spellName) => castSpell(form, spellName))
    .filter((pair) => pair.result);
}
